import { track, EventTypes } from '@mc/track-event'

export const trackPlaylistModule = (item: { slug: string; title: string }) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    class: item.slug,
    category: 'video-playlist-module',
    location: 'hero',
    action: item.title,
    page_category: 'class',
    page_path: window.location.pathname,
  })
}

export const trackTrailerVideoPlay = ({
  course: { slug, title, brightcoveVideoId, mediaUuid = '' },
}: {
  course: {
    slug: string
    title: string
    brightcoveVideoId?: string
    mediaUuid: string
  }
}) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    class: slug,
    category: 'media-playback',
    location: 'about-this-class',
    action: 'Course Trailer',
    path: window.location.pathname,
    content_id: brightcoveVideoId ?? mediaUuid,
    content_title: title,
  })
}

export const trackSampleVideoPlay = ({
  course: { slug, title, sample },
}: {
  course: {
    slug: string
    title: string
    sample?: { brightcoveVideoId?: string; mediaUuid: string }
  }
}) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    class: slug,
    category: 'media-playback',
    location: 'about-this-class',
    action: 'Course Preview',
    path: window.location.pathname,
    content_id: sample?.brightcoveVideoId ?? sample?.mediaUuid,
    content_title: title,
  })
}

export const trackSubcatPillClick = (
  subcategoryName: string,
  primaryCategoryName: string,
) => {
  track(EventTypes.COURSE_MARKETING_CLICK, {
    category: primaryCategoryName,
    location: 'lesson_details',
    action: `subcategory: ${subcategoryName}`,
  })
}
